/* MOSAIK Craft gallery controls v5.
   Main arrows deliberately drive Craft's already-working thumbnail buttons.
   This avoids relying on SliderComponent page calculations, which are disabled
   on desktop when inactive product media are hidden. Because Craft itself owns
   the thumbnail click behavior, images, hosted video, external video, active
   thumbnail state and lightbox behavior remain native. */
(() => {
  const desktop = window.matchMedia('(min-width: 990px)');

  function moveMainGallery(arrow, direction) {
    if (!desktop.matches) return;

    const gallery = arrow.closest('media-gallery');
    if (!gallery) return;

    const thumbnailItems = Array.from(
      gallery.querySelectorAll("slider-component[id^='GalleryThumbnails-'] [data-target]")
    ).filter((item) => item.querySelector('button'));

    if (thumbnailItems.length < 2) return;

    let currentIndex = thumbnailItems.findIndex((item) =>
      item.querySelector('button[aria-current="true"]')
    );

    // Fallback: match Craft's active media to its thumbnail target.
    if (currentIndex < 0) {
      const activeMedia = gallery.querySelector("slider-component[id^='GalleryViewer-'] [data-media-id].is-active");
      const activeId = activeMedia?.dataset?.mediaId;
      if (activeId) currentIndex = thumbnailItems.findIndex((item) => item.dataset.target === activeId);
    }

    if (currentIndex < 0) currentIndex = 0;
    const nextIndex = (currentIndex + direction + thumbnailItems.length) % thumbnailItems.length;
    const targetButton = thumbnailItems[nextIndex].querySelector('button');
    if (targetButton) targetButton.click();
  }

  function scrollThumbRail(button, direction) {
    if (!desktop.matches) return;
    const gallery = button.closest('media-gallery');
    const list = gallery?.querySelector("slider-component[id^='GalleryThumbnails-'] .thumbnail-list");
    if (!list) return;
    const first = list.querySelector('.thumbnail-list__item');
    const step = first ? first.getBoundingClientRect().height + 12 : 100;
    list.scrollBy({ top: direction * step * 3, behavior: 'smooth' });
  }

  // Event delegation makes the controls work even after Shopify re-renders
  // the product section in the theme editor or after variant changes.
  document.addEventListener('click', (event) => {
    const next = event.target.closest?.('.mosaik-gallery-arrow--next');
    if (next) {
      event.preventDefault();
      event.stopPropagation();
      moveMainGallery(next, 1);
      return;
    }

    const prev = event.target.closest?.('.mosaik-gallery-arrow--prev');
    if (prev) {
      event.preventDefault();
      event.stopPropagation();
      moveMainGallery(prev, -1);
      return;
    }

    const down = event.target.closest?.('.mosaik-thumb-arrow--down');
    if (down) {
      event.preventDefault();
      event.stopPropagation();
      scrollThumbRail(down, 1);
      return;
    }

    const up = event.target.closest?.('.mosaik-thumb-arrow--up');
    if (up) {
      event.preventDefault();
      event.stopPropagation();
      scrollThumbRail(up, -1);
    }
  });
})();
